/* Booking-flow hero (promoted to shared in CWR 2.6; from 2.5 §3-A). PINNED
   scroll-over-hero, identical mechanics to the 2.4 SessionDetail hero
   (position:absolute, 330px, z-index 0 behind the scroller; a transparent
   .heroSpacer in the scroller is the window, and the sheet rises over it) so the
   image sits in the SAME position page-to-page and stays put while the sheet
   scrolls. On injected client tokens; the dark scrim is image-space (mirrors 2.4). */

.hero {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 0;
  height: 330px;
  background-color: var(--glass-bg-strong);
  background-size: cover;
  background-position: center;
}
.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  /* The top band only; the fade under the words rides the caption (.cap::before). */
  background: linear-gradient(180deg, rgba(var(--bg-page-rgb), 0.35) 0%, rgba(var(--bg-page-rgb), 0) 28%);
}
.heroFallback {
  background-image: linear-gradient(135deg, var(--glass-bg-strong), var(--bg-page));
}
.heroMuted {
  filter: saturate(0.55);
}

.cap {
  /* Option 3's glow behind each small line, in the page color (the name has its own, softer). */
  --hero-line-glow: 0 0 3px rgba(var(--bg-page-rgb), 0.9), 0 1px 10px var(--bg-page), 0 0 22px rgba(var(--bg-page-rgb), 0.9);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  padding: 0 22px 16px;
}
/* Gabriel 2026-10-22: the fade under the caption ends near the top of the eyebrow
   ("Your booking") instead of reaching up the photo, however many lines the name takes.
   The strength of option 3 (2026-10-21, "go with 3."), in the page color so a light look
   fades light; the detail pages' caption uses the same fade (SessionDetailPage .heroCap). */
.cap::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: -14px;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(var(--bg-page-rgb), 0) 0%,
    rgba(var(--bg-page-rgb), 0.5) 28%,
    rgba(var(--bg-page-rgb), 0.82) 62%,
    var(--bg-page) 100%
  );
}
.eyebrow {
  font-family: var(--client-font-body, 'Outfit', system-ui, sans-serif);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--accent);
  text-shadow: var(--hero-line-glow);
}
.name {
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 600;
  font-size: 28px;
  letter-spacing: -0.012em;
  line-height: 1.05;
  color: var(--text-primary);
  margin-top: 6px;
  text-shadow: 0 0 4px rgba(var(--bg-page-rgb), 0.6), 0 2px 18px var(--bg-page);
}
.when {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 12.5px;
  color: var(--text-secondary);
  margin-top: 8px;
  text-shadow: var(--hero-line-glow);
}
.whenEmphasized {
  font-size: 13.5px;
  line-height: 1.4;
}
.whenParts {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}
.when b {
  color: var(--text-primary);
  font-weight: 500;
}
.av {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 0 1px rgba(var(--accent-rgb), 0.5);
  flex-shrink: 0;
  display: grid;
  place-items: center;
  font-size: 9px;
  font-weight: 700;
  color: var(--text-primary);
}
